import { AnalyticsRuntimeEffect, AuthWatchEffect, ServiceWorkerRuntimeEffect } from './runtime';

export function RuntimeEffects() {
  return (
    <>
      <AuthWatchEffect />
      <AnalyticsRuntimeEffect />
      <ServiceWorkerRuntimeEffect />
    </>
  );
}
